import * as fp from 'lodash/fp';
import { format } from 'date-fns';
import { OperatingTime, Week } from '~/types/common';

export default function isInOperatingTime(
  operatingTime: OperatingTime,
  date: Date | null,
): boolean {
  if (!fp.isDate(date)) {
    return false;
  }

  const week = format(date, 'EEE').toUpperCase() as Week;

  const dateMin = date.getHours() * 60 + date.getMinutes();

  return operatingTime[week].some(
    ({ start, end }) => fp.gte(dateMin, start) && fp.lte(dateMin, end),
  );
}
